const Polkadotters = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 512 512"
    xmlSpace="preserve"
  >
    <g transform="translate(-1200)">
      <circle fill="#fdebf3" fillOpacity={0.33} cx={1286.7} cy={105.8} r={20} />
      <circle fill="#fdebf3" fillOpacity={0.33} cx={1261.7} cy={155.8} r={20} />
      <circle fill="#fdebf3" fillOpacity={0.33} cx={1248.7} cy={205.8} r={20} />
      <circle fill="#fdebf3" fillOpacity={0.33} cx={1261.7} cy={255.8} r={20} />
      <circle fill="#fdebf3" fillOpacity={0.33} cx={1274.7} cy={305.8} r={20} />
      <circle fill="#fdebf3" fillOpacity={0.33} cx={1261.7} cy={355.8} r={20} />
      <circle fill="#fdebf3" fillOpacity={0.33} cx={1236.7} cy={405.8} r={20} />
    </g>
    <g transform="translate(-1200)">
      <circle fill="#fdebf3" fillOpacity={0.66} cx={1336.7} cy={105.8} r={20} />
      <circle fill="#fdebf3" fillOpacity={0.66} cx={1311.7} cy={155.8} r={20} />
      <circle fill="#fdebf3" fillOpacity={0.66} cx={1298.7} cy={205.8} r={20} />
      <circle fill="#fdebf3" fillOpacity={0.66} cx={1311.7} cy={255.8} r={20} />
      <circle fill="#fdebf3" fillOpacity={0.66} cx={1324.7} cy={305.8} r={20} />
      <circle fill="#fdebf3" fillOpacity={0.66} cx={1311.7} cy={355.8} r={20} />
      <circle fill="#fdebf3" fillOpacity={0.66} cx={1286.7} cy={405.8} r={20} />
    </g>
    <g transform="translate(-1200)">
      <circle fill="#ee4699" cx={1386.7} cy={105.8} r={20} />
      <circle fill="#ee4699" cx={1361.7} cy={155.8} r={20} />
      <circle fill="#ee4699" cx={1348.7} cy={205.8} r={20} />
      <circle fill="#ee4699" cx={1361.7} cy={255.8} r={20} />
      <circle fill="#ee4699" cx={1374.7} cy={305.8} r={20} />
      <circle fill="#ee4699" cx={1361.7} cy={355.8} r={20} />
      <circle fill="#ee4699" cx={1336.7} cy={405.8} r={20} />
    </g>
    <g transform="translate(-1200)">
      <circle fill="#bbb" cx={1491.7} cy={120.8} r={20} />
      <circle fill="#bbb" cx={1536.7} cy={105.8} r={20} />
      <circle fill="#bbb" cx={1586.7} cy={105.8} r={20} />
      <circle fill="#bbb" cx={1631.7} cy={121.8} r={20} />
      <circle fill="#bbb" cx={1461.7} cy={155.8} r={20} />
      <circle fill="#bbb" cx={1661.7} cy={155.8} r={20} />
      <circle fill="#bbb" cx={1446.7} cy={205.8} r={20} />
      <circle fill="#bbb" cx={1536.7} cy={205.8} r={20} />
      <circle fill="#bbb" cx={1675.7} cy={205.8} r={20} />
      <circle fill="#bbb" cx={1511.7} cy={255.8} r={20} />
      <circle fill="#bbb" cx={1661.7} cy={255.8} r={20} />
      <circle fill="#bbb" cx={1486.7} cy={305.8} r={20} />
      <circle fill="#bbb" cx={1536.7} cy={305.8} r={20} />
      <circle fill="#bbb" cx={1586.7} cy={305.8} r={20} />
      <circle fill="#bbb" cx={1631.7} cy={290.8} r={20} />
      <circle fill="#bbb" cx={1461.7} cy={355.8} r={20} />
      <circle fill="#bbb" cx={1436.7} cy={405.8} r={20} />
    </g>
    <circle cx={336.7} cy={405.8} r={20} fill="#ed1e7f" />
  </svg>
);

export default Polkadotters;
